// import { 
//     useSelector, 
//     //useDispatch 
// } 
// from 'react-redux';
// //import { ModifyZoneStore } from 'app-store/actions/ModifyZoneStore';



//import { Settings } from 'app-components/Prime/Data.js';

import { 

    //VPformTemplateOwnr,
    //VPformTemplateEmpl,
    //VPformTemplateExpense,

    //VPcompanyInfo, 
    VPexpenses,
    VPincome,   
    VPoverhead, 

    VPownrsIndirect,  
    //VPownrs,
    VPownr,

    //VPemplsYearly, 
    //VPemplsMonthly, 
    //VPemplsDirect,
    VPemplsIndirect,
    VPempl


} from 'app-components/Prime/VPdata/form.js';



// import { VPreportDefaults } from 'app-components/Prime/VPdata/reports';


// import { 

//     ChartColorsA, 
//     //ChartColorsB, 
//     //ChartColorsC 

// } from 'utils/components/Charts/ChartColors';


import { LibBase, LibNumber } from "library";


// import ApiResources from 'utils/components/Pages/ApiResources';


const Index = (props) => {



    //-------------------------------------------

    // var apiDomain;
    // var hostname;
    // //var hostname = window.location.hostname;//returns the domain name of the web host
    // var protocol = window.location.protocol;//returns the web protocol used (http: or https:)

    // if(window.location.hostname.match(/192.168/gi))
    // {
    //     hostname = ApiResources.network['3001'].vpc;
    //     apiDomain = protocol + "//" + hostname + "/";
    // }
    // else
    // if(window.location.hostname.match(/localhost/gi))
    // {
    //     hostname = ApiResources.local['3001'].vpc;
    //     apiDomain = protocol + "//" + hostname + "/";
    // }else{
    //     hostname = ApiResources.aws['x'].vpc;
    //     apiDomain = "https://" + hostname + "/";
    // }//=

    //-------------------------------------------

    //console.log("API DOMAIN: "+apiDomain);


    //const apiCall = 'alter-calc-test';
    //const apiCall = 'alter-calc-dash';




    // -- redux -- //
    //const dispatch = useDispatch();
    //const zoneObj = useSelector(state => state.zone);
    //console.log("zoneObj: "+JSON.stringify(zoneObj, null, 2));


    const zoneObj = props.zoneObj;




    var overhead_percent;
    //var overhead_percent_int = 0;
    var owners = {};   
    var employees = {};
    //var expenses = {};

    overhead_percent = 0.0 + "%";



    var index;

    var keyname;
    var kn;
    var item;
    var value;
    var newValue;

    var a,b,c,d;
    var total;
    var grand_total;


    //var chartSections;
    // var object;
    // var percent;
    // var count;

    //var pgraph;


    var obj;

    // var chartColors = ChartColorsA;




    //clear VPoverhead
    for(keyname in VPoverhead)
    {
        if(keyname.match(/expense-/gi))
        {
            delete VPoverhead[keyname];
        }
    }

    var cards_overhead = LibBase.CloneIt(VPoverhead);
    var cards_owners = LibBase.CloneIt(VPownrsIndirect);
    var cards_employees = LibBase.CloneIt(VPemplsIndirect);


    //var templateExpenseForm;
    //var newTemplateExpenseForm;
    


    //var templateEmplForm;
    //var newTemplateEmplForm;
    
    //var template_empl;



    var piePerc;
    var pieSlice;
    var pieChart = {

        items: [ 

            {
                name:"Business",
                value:14
            },
            {
                name:"Facility",
                value:20
            }, 
            {
                name:"Equip. Software",
                value:30
            },      
            {
                name:"Vehicles",
                value:12
            },

            {
                name:"Owners",
                value:5
            },
            {
                name:"Employees",
                value:5
            },


        ],

        colors: [

            "#fde23e",
            "#f16e23", 
            "#57d9ff",
            "#937e88",
            "#20b2aa",
            "#ccff00"

        ],


        hole:{

            percent         :"0.0",
            name            :"Overhead",
            color           :"#181b21",
            outlineColor    :"#181b21",
            textColor       :"white"
        }



    };






    var isOkay;
    isOkay = false;
    if(zoneObj.calc_dash 
    && zoneObj.calc_dash !== undefined
    )
    {
        if(Object.keys(zoneObj.calc_dash.form_items).length > 0
        && Object.keys(zoneObj.calc_dash.result_items).length > 0
        )
        {
            isOkay = true;
        }

    }
    if(isOkay)
    {


        grand_total = zoneObj.calc_dash.result_items['totals'].total;
        grand_total = parseFloat(grand_total);


        //console.log("FORM ITEMS: "+JSON.stringify(zoneObj.calc_dash.form_items));

        index=0;
        for(keyname in zoneObj.calc_dash.form_items)
        {

            // -- owners -- //

            if(keyname.match(/ownr/gi))
            {

                //idl_employees[keyname] = zoneObj.calc_dash.form_items[keyname];

                
                //order card item based on Prime VPdata
                //item = zoneObj.calc_dash.form_items[keyname];
                item = LibBase.CloneIt(zoneObj.calc_dash.form_items[keyname]);//Deep Clone
          
          
                //value = VPowner.value;
                value = LibBase.CloneIt(VPownr.value);//Deep Clone
                newValue = {};
                for(kn in value)
                {
                    if(kn === 'ownr_call') 
                    {
                    }else{
                        newValue[kn] = item.value[kn];       
                    }
                    
                }
                owners[keyname] = {
                    name:item.name,
                    value:newValue
                };
                

            }




            // -- employees -- //

            else
            if(keyname.match(/empl/gi))
            {

                //idl_employees[keyname] = zoneObj.calc_dash.form_items[keyname];

                
                //order card item based on Prime VPdata
                //item = zoneObj.calc_dash.form_items[keyname];
                item = LibBase.CloneIt(zoneObj.calc_dash.form_items[keyname]);//Deep Clone
          
                //value = VPemployee.value;
                value = LibBase.CloneIt(VPempl.value);//Deep Clone
                newValue = {};
                for(kn in value)
                {
                    newValue[kn] = item.value[kn];
                }
                employees[keyname] = {
                    name:item.name,
                    value:newValue
                };
                



            }



            // -- overhead -- //

            else
            {
                
                //console.log("KEYNAME: "+keyname);

                item = LibBase.CloneIt(zoneObj.calc_dash.form_items[keyname]);//Deep Clone
                //console.log(JSON.stringify(item,null,2));


                if(keyname.match(/expense-/gi))
                {

                    // TM: order inputs here



                    // -- VPoverhead -- //

                    if(item.order)
                    {
                        newValue = {};
                        for(obj of item.order)
                        {
                            //console.log("order:  "+obj);
                            for(kn in item.value)
                            {
                                //console.log("kn:  "+kn);
                                if(obj === kn)
                                {
                                    //console.log("match: "+kn);
                                    newValue[kn] = item.value[kn];
                                }
                            }

                        }
                        //console.log(JSON.stringify(newValue,null,2));

                        VPoverhead[keyname] = {
                            name:item.name,
                            value:newValue,
                            order:item.order
                        };


                    }else{

                        VPoverhead[keyname] = {
                            name:item.name,
                            value:item.value
            
                        };

                    }






                    // -- card_overhead -- //

                    value = LibBase.CloneIt(item.value);//Deep Clone

                    if(item.order)
                    {
                        newValue = {};
                        for(obj of item.order)
                        {
                            //console.log("order:  "+obj);
                            for(kn in item.value)
                            {
                                //console.log("kn:  "+kn);
                                if(obj === kn)
                                {
                                    //console.log("match: "+kn);
                                    newValue[kn] = item.value[kn];
                                }
                            }

                        }
                        //console.log(JSON.stringify(newValue,null,2));


                        total = 0;
                        for(kn in newValue)
                        {
                            obj = newValue[kn];
                            total = parseFloat(total) + parseFloat(obj.value);
      
                        }
                        total = parseFloat(total);
                        total = total.toFixed(2);
                        // console.log("TOTALLLLLLLLLLLLL "+total);
                        newValue["total"] = total;
                        newValue["total_percent"] = 0;
    
                        cards_overhead[keyname] = {
                            name:item.name,
                            value:newValue,
                            order:item.order
                        };
    

                    }else{

                        total = 0;
                        for(kn in value)
                        {
                            obj = value[kn];
                            total = parseFloat(total) + parseFloat(obj.value);
      
                        }
                        total = parseFloat(total);
                        total = total.toFixed(2);
                        // console.log("TOTALLLLLLLLLLLLL "+total);
                        value["total"] = total;
                        value["total_percent"] = 0;
    
                        cards_overhead[keyname] = {
                            name:item.name,
                            value:value
                        };
    
                    }





                }else{

                    //value = VPoverhead[keyname].value;
                    value = LibBase.CloneIt(VPoverhead[keyname].value);//Deep Clone
                    newValue = {};
                    for(kn in value)
                    {
                        newValue[kn] = item.value[kn];
                    }

                    VPoverhead[keyname] = {
                        name:item.name,
                        value:newValue
                    };

                    cards_overhead[keyname] = {

                        name:item.name,
                        value:newValue

                    };                

                }


        
                // -- set totals for cards -- //

                if(keyname.match(/expense-/gi))
                {
                    total = 0;
                    newValue = 0;
                    for(kn in item.value)
                    {
                        //console.log(value[kn]);
                        if(item.value[kn] !== undefined)
                        {
                            newValue = item.value[kn].value;
                            if(!isNaN(newValue)) parseFloat(newValue);
                            else newValue = 0;
                            total = parseFloat(total) + parseFloat(newValue); 
                        }
    
                    }
                    total = parseFloat(total);        
                    total = total.toFixed(2);
                

                    piePerc = ( parseFloat(total)/parseFloat(grand_total) ) * 100;
                    if(isNaN(piePerc) || grand_total === 0) piePerc = 0;
                    piePerc = piePerc.toFixed(1);
                    piePerc = parseFloat(piePerc);



                    cards_overhead[keyname].value['total_percent'] = {
    
                        name: "Total Monthly (Overhead %)",
                        default: 0,
                        print: "percent",
                        value: piePerc,
                        required: true
    
                    };
                    cards_overhead[keyname].value['total'] = {
    
                        name: "Total Monthly (Overhead $)",
                        default: 0,
                        print: "price",
                        value: total,
                        required: true
    
                    };


                    // -- set pieChart data -- //

                    for(pieSlice of pieChart.items)
                    {
                        if(pieSlice.value !== piePerc)
                        {
                            pieChart.items[index].name = item.name;      
                            pieChart.items[index].value = piePerc;
                            break;
            
                        }
                       
                    }
                    index++;


                }//==




            }

        }// -- for





        //VPexpenses.value.monthly_expenses.value = grand_total;
        VPexpenses.value.monthly_expenses.value = grand_total;
        VPincome.value.projected_monthly_sales.value = zoneObj.calc_dash.form_items['settings'].value.projected_monthly_sales.value;


        overhead_percent = zoneObj.calc_dash.result_items['overhead'].overhead;
        overhead_percent = parseFloat(overhead_percent); 

        // overhead_percent_int = overhead_percent.toFixed(1);

        pieChart.hole.percent = overhead_percent.toFixed(1);

        overhead_percent = overhead_percent.toFixed(1) + "%";




        //console.log("IDL EMPLOYEES: "+JSON.stringify(idl_employees,null,2));

    
        /*
        for(keyname in zoneObj.calc_dash.result_items)
        {

            console.log("KEYNAME: "+keyname);

            item = zoneObj.calc_dash.result_items[keyname];
            console.log(JSON.stringify(item,null,2));

        
        }// -- for
        */





        //------------------------------------------
        // -- owners - totals - cards 
        //------------------------------------------

        //var total_ownr_salary_pretax_yearly_indirect
        var total_ownr_salary_pretax_monthly_indirect;
        var total_ownr_health_insurance_monthly;
        var total_ownr_ira_monthly_indirect;
        var total_ownr_taxes_monthly_indirect;  

        total_ownr_salary_pretax_monthly_indirect = zoneObj.calc_dash.result_items['totals'].total_ownr_salary_pretax_monthly_indirect;
        total_ownr_health_insurance_monthly = zoneObj.calc_dash.result_items['totals'].total_ownr_health_insurance_monthly;
        total_ownr_ira_monthly_indirect = zoneObj.calc_dash.result_items['totals'].total_ownr_ira_monthly_indirect;
        total_ownr_taxes_monthly_indirect = zoneObj.calc_dash.result_items['totals'].total_ownr_taxes_monthly_indirect;  

        //total_ownr_salary_pretax_yearly_indirect = parseFloat(total_ownr_salary_pretax_monthly_indirect) * 12;


        //if(isNaN(total_ownr_salary_pretax_yearly_indirect)) total_ownr_salary_pretax_yearly_indirect = 0;
        if(isNaN(total_ownr_salary_pretax_monthly_indirect)) total_ownr_salary_pretax_monthly_indirect = 0;
        if(isNaN(total_ownr_health_insurance_monthly)) total_ownr_health_insurance_monthly = 0;
        if(isNaN(total_ownr_ira_monthly_indirect)) total_ownr_ira_monthly_indirect = 0;
        if(isNaN(total_ownr_taxes_monthly_indirect)) total_ownr_taxes_monthly_indirect = 0;


        //cards_owners.value.ownr_salary_pretax_yearly_indirect.value = total_ownr_salary_pretax_yearly_indirect;
        cards_owners.value.ownr_salary_pretax_monthly_indirect.value = total_ownr_salary_pretax_monthly_indirect;
        cards_owners.value.ownr_health_insurance_monthly.value = total_ownr_health_insurance_monthly;
        cards_owners.value.ownr_ira_monthly_indirect.value = total_ownr_ira_monthly_indirect;
        cards_owners.value.ownr_taxes_monthly_indirect.value = total_ownr_taxes_monthly_indirect;



        // -- card total - indirect labor -- //

        total = 0;
        if(total_ownr_salary_pretax_monthly_indirect !== undefined
        && total_ownr_health_insurance_monthly !== undefined 
        && total_ownr_ira_monthly_indirect !== undefined
        && total_ownr_taxes_monthly_indirect !== undefined
        )
        {
            a = total_ownr_salary_pretax_monthly_indirect;
            b = total_ownr_health_insurance_monthly;
            c = total_ownr_ira_monthly_indirect;
            d = total_ownr_taxes_monthly_indirect;

            total = parseFloat(a) + parseFloat(b) + parseFloat(c) + parseFloat(d);

        }

        piePerc = ( parseFloat(total)/parseFloat(grand_total) ) * 100;
        if(isNaN(piePerc)) piePerc = 0;
        piePerc = piePerc.toFixed(1);
        piePerc = parseFloat(piePerc);

        cards_owners.value['total_percent'] = {
    
            name: "Total Monthly (Overhead %)",
            default: 0,
            print: "percent",
            value: piePerc,
            required: true

        };
        cards_owners.value['total'] = {

            name: "Total Monthly (Overhead $)",
            default: 0,
            print: "price",
            value: total,
            required: true

        };

        // -- set pieChart data -- //

        pieSlice = pieChart.items[pieChart.items.length-2];
        if(pieSlice.value !== piePerc)
        {
            pieSlice.name = "Owners";      
            pieSlice.value = piePerc;

        }
        








        //------------------------------------------
        // -- employees - totals - cards 
        //------------------------------------------

        //var total_empl_indirect_salary_yearly;
        var total_empl_indirect_salary_monthly;
        var total_empl_indirect_tax_monthly;
        var total_empl_indirect_ira_monthly;
        var total_empl_health_insurance_monthly;

        total_empl_indirect_salary_monthly = zoneObj.calc_dash.result_items['totals'].total_empl_indirect_salary_monthly;
        total_empl_indirect_tax_monthly = zoneObj.calc_dash.result_items['totals'].total_empl_indirect_tax_monthly;
        total_empl_indirect_ira_monthly = zoneObj.calc_dash.result_items['totals'].total_empl_indirect_ira_monthly;
        total_empl_health_insurance_monthly = zoneObj.calc_dash.result_items['totals'].total_empl_health_insurance_monthly;
   
        //total_empl_indirect_salary_yearly = parseFloat(total_empl_indirect_salary_monthly) * 12;

        //if(isNaN(total_empl_indirect_salary_yearly)) total_empl_indirect_salary_yearly = 0;
        if(isNaN(total_empl_indirect_salary_monthly)) total_empl_indirect_salary_monthly = 0;
        if(isNaN(total_empl_indirect_tax_monthly)) total_empl_indirect_tax_monthly = 0;
        if(isNaN(total_empl_indirect_ira_monthly)) total_empl_indirect_ira_monthly = 0;
        if(isNaN(total_empl_health_insurance_monthly)) total_empl_health_insurance_monthly = 0;
     
        //cards_employees.value.empl_indirect_salary_yearly.value = total_empl_indirect_salary_yearly;
        cards_employees.value.empl_indirect_salary_monthly.value = total_empl_indirect_salary_monthly;
        cards_employees.value.empl_indirect_tax_monthly.value = total_empl_indirect_tax_monthly;      
        cards_employees.value.empl_indirect_ira_monthly.value = total_empl_indirect_ira_monthly;
        cards_employees.value.empl_health_insurance_monthly.value = total_empl_health_insurance_monthly;







        // -- card total - indirect labor -- //

        total = 0;
        if(total_empl_indirect_salary_monthly !== undefined
        && total_empl_indirect_ira_monthly !== undefined
        && total_empl_indirect_tax_monthly !== undefined        
        && total_empl_health_insurance_monthly !== undefined 
        )
        {
            a = total_empl_indirect_salary_monthly;
            b = total_empl_indirect_ira_monthly;
            c = total_empl_indirect_tax_monthly;        
            d = total_empl_health_insurance_monthly;

            total = parseFloat(a) + parseFloat(b) + parseFloat(c) + parseFloat(d);

        }

        piePerc = ( parseFloat(total)/parseFloat(grand_total) ) * 100;
        if(isNaN(piePerc)) piePerc = 0;
        piePerc = piePerc.toFixed(1);
        piePerc = parseFloat(piePerc);

        cards_employees.value['total_percent'] = {
    
            name: "Total Monthly (Overhead %)",
            default: 0,
            print: "percent",
            value: piePerc,
            required: true

        };
        cards_employees.value['total'] = {

            name: "Total Monthly (Overhead $)",
            default: 0,
            print: "price",
            value: total,
            required: true

        };

        // -- set pieChart data -- //

        pieSlice = pieChart.items[pieChart.items.length-1];
        if(pieSlice.value !== piePerc)
        {
            pieSlice.name = "Employees";      
            pieSlice.value = piePerc;

        }
        


    }// -- if

    //console.log("pieChart: "+JSON.stringify(pieChart,null,2));

    //_overhead = VPoverhead;
    //console.log("_overhead B: "+JSON.stringify(_overhead,null,2));


    //console.log("VPoverhead: "+JSON.stringify(VPoverhead,null,2));
    //console.log("cards_overhead: "+JSON.stringify(cards_overhead,null,2));






    // var actual_monthly_expenses;
    // actual_monthly_expenses = VPexpenses.value.monthly_expenses.value;
    // actual_monthly_expenses = parseFloat(actual_monthly_expenses).toFixed(2);
    // actual_monthly_expenses = "$"+LibNumber.PrintMoney(actual_monthly_expenses);


    // var bulletColors = {};
    // var donut_items = [];

    // var total_expenses = "0.00";
    // var total_empls_indirect = "0.00";
    // var total_ownrs_indirect = "0.00";
    // var total_indirects = "0.00";
    // var total_expenses_indirects = "0.00";

    // var display_total_expenses = "0.00";
    // // var display_total_ownrs_indirect = "0.00";
    // // var display_total_empls_indirect = "0.00";
    // var display_total_indirects = "0.00";
    // //var display_total_expenses_indirects = "0.00";

    // if(zoneObj.calc_dash)
    // {

    //     total_expenses = zoneObj.calc_dash.result_items['totals'].total_expenses;
    //     total_expenses = parseFloat(total_expenses).toFixed(2);

    //     total_ownrs_indirect = zoneObj.calc_dash.result_items['totals'].total_ownrs_indirect;
    //     total_ownrs_indirect = parseFloat(total_ownrs_indirect).toFixed(2);

    //     total_empls_indirect = zoneObj.calc_dash.result_items['totals'].total_empls_indirect;
    //     total_empls_indirect = parseFloat(total_empls_indirect).toFixed(2);


    //     total_indirects = parseFloat(total_ownrs_indirect) + parseFloat(total_empls_indirect);
    //     total_indirects = parseFloat(total_indirects).toFixed(2);


    //     total_expenses_indirects = parseFloat(total_expenses) + parseFloat(total_indirects);

  
    //     count = 0;
    //     for(keyname in cards_overhead)
    //     {
    //         if(keyname.match(/expense-/gi))
    //         {
    //             object = cards_overhead[keyname];
    //             total = object.value.total.value;
    //             percent = (parseFloat(total) / parseFloat(total_expenses)) * 100;
    //             donut_items.push({
    //                 "name": object.name,
    //                 "value": object.value.total.value,
    //                 "percent": percent,
    //                 "color": chartColors[count]
    //             });
    //             //console.log("-----"+JSON.stringify(object,null,2));

    //             bulletColors[keyname] = chartColors[count];
    //             count++;
    //         }
      

    //     }
    //     //console.log("donut_items: "+JSON.stringify(donut_items,null,2));

    //     // total_expenses = "$"+LibNumber.PrintMoney(total_expenses);
    //     // total_ownrs_indirect = "$"+LibNumber.PrintMoney(total_ownrs_indirect);
    //     // total_empls_indirect = "$"+LibNumber.PrintMoney(total_empls_indirect);

    //     // total_indirects_money = "$"+LibNumber.PrintMoney(total_indirects);


    //     display_total_expenses = "$"+LibNumber.PrintMoney(total_expenses);
    //     // display_total_ownrs_indirect = "$"+LibNumber.PrintMoney(total_ownrs_indirect);
    //     // display_total_empls_indirect = "$"+LibNumber.PrintMoney(total_empls_indirect);
    //     display_total_indirects = "$"+LibNumber.PrintMoney(total_indirects);


    // }




    // //============================================================================

    // var actual_monthly_expenses, actual_monthly_expenses_decimal, actual_monthly_expenses_percent;
    // var projected_monthly_sales, projected_monthly_sales_decimal, projected_monthly_sales_percent;
    // var total_monthlys;

    // var display_actual_monthly_expenses;
    // var display_projected_monthly_sales;



    // actual_monthly_expenses = VPexpenses.value.monthly_expenses.value;
    // projected_monthly_sales = VPincome.value.projected_monthly_sales.value;
    // total_monthlys = parseFloat(actual_monthly_expenses) + parseFloat(projected_monthly_sales);

    // actual_monthly_expenses_decimal = parseFloat(actual_monthly_expenses) / parseFloat(total_monthlys);
    // projected_monthly_sales_decimal = parseFloat(projected_monthly_sales) / parseFloat(total_monthlys);

    // actual_monthly_expenses_percent = parseFloat(actual_monthly_expenses_decimal) * 100;
    // projected_monthly_sales_percent = parseFloat(projected_monthly_sales_decimal) * 100;


    // actual_monthly_expenses = parseFloat(actual_monthly_expenses).toFixed(2);
    // projected_monthly_sales = parseFloat(projected_monthly_sales).toFixed(2);

    // // actual_monthly_expenses = "$"+LibNumber.PrintMoney(actual_monthly_expenses);
    // // projected_monthly_sales = "$"+LibNumber.PrintMoney(projected_monthly_sales);

    // display_actual_monthly_expenses = "$"+LibNumber.PrintMoney(actual_monthly_expenses);
    // display_projected_monthly_sales = "$"+LibNumber.PrintMoney(projected_monthly_sales);




    // donut_items.push({

    //     "name": "Actual Monthly Expenses",
    //     "value": display_actual_monthly_expenses,
    //     "percent": actual_monthly_expenses_percent

    // });   
    // donut_items.push({

    //     "name": "Projected Monthly Sales",
    //     "value": display_projected_monthly_sales,
    //     "percent": projected_monthly_sales_percent

    // });







    // var actual_monthly_expenses;
    // actual_monthly_expenses = VPexpenses.value.monthly_expenses.value;
    // actual_monthly_expenses = parseFloat(actual_monthly_expenses).toFixed(2);
    // actual_monthly_expenses = "$"+LibNumber.PrintMoney(actual_monthly_expenses);


    // var bulletColors = {};
    // var donut_items = [];
    // var total_expenses = "0.00";

    // if(zoneObj.calc_dash)
    // {
    //     total_expenses = zoneObj.calc_dash.result_items['totals'].total_expenses;
    //     total_expenses = parseFloat(total_expenses).toFixed(2);
  
    //     count = 0;
    //     for(keyname in cards_overhead)
    //     {
    //         if(keyname.match(/expense-/gi))
    //         {
    //             object = cards_overhead[keyname];
    //             total = object.value.total.value;
    //             percent = (parseFloat(total) / parseFloat(total_expenses)) * 100;
    //             donut_items.push({
    //                 "name": object.name,
    //                 "value": object.value.total.value,
    //                 "percent": percent,
    //                 "color": chartColors[count]
    //             });
    //             //console.log("-----"+JSON.stringify(object,null,2));

    //             bulletColors[keyname] = chartColors[count];
    //             count++;
    //         }
      

    //     }
    //     //console.log("donut_items: "+JSON.stringify(donut_items,null,2));

    //     total_expenses = "$"+LibNumber.PrintMoney(total_expenses);

    // }





    // var gaugeItems = [

    //     {

    //         "name": "Color ( 37.5% )",
    //         "value": "$1,100.00",
    //         "percent":overhead_percent_int       
    //     },
    //     {

    //         "name": "Blank ( 37.5% )",
    //         "value": "$1,100.00",
    //         "percent":(100 - overhead_percent_int)

    //     }

    // ];
    // if(overhead_percent_int)
    // {
    //     //alert(overhead_percent_int+"\n"+(100-overhead_percent_int));

    //     gaugeItems = [

    //         {

    //             "name": "Color ( 37.5% )",
    //             "value": "$1,100.00",
    //             "percent":overhead_percent_int       
    //         },
    //         {
    
    //             "name": "Blank ( 37.5% )",
    //             "value": "$1,100.00",
    //             "percent":(100 - overhead_percent_int)
    
    //         }

    //     ];

    // }




    // var expenses_indirects_report = {

    //     "name": "Expenses / Indirects",
    //     "value": {

    //         "ei_zyx_expenses": {
    //             "name": "Expenses",
    //             "default": "",
    //             "print": "price",
    //             "value": total_expenses,
    //             "required": true
    //         },
    //         "ei_zyx_ownrs_indirects": {
    //             "name": "Owner's Indirects",
    //             "default": "",
    //             "print": "price",
    //             "value": total_ownrs_indirect,
    //             "required": true
    //         },
    //         "ei_zyx_empls_indirects": {
    //             "name": "Employee's Indirects",
    //             "default": "",
    //             "print": "price",
    //             "value": total_empls_indirect,
    //             "required": true
    //         },

    //         "total": {
    //             "name": "Total Monthly (Overhead $)",
    //             "default": 0,
    //             "print": "price",
    //             "value": total_expenses_indirects,
    //             "required": true
    //         },
    //         "total_percent": {
    //             "name": "Total Monthly (Overhead %)",
    //             "default": 0,
    //             "print": "percent",
    //             "value": 100,
    //             "required": true
    //         }

    //     },
    //     "order": [
    //         "ei_zyx_expenses",
    //         "ei_zyx_ownrs_indirects",
    //         "ei_zyx_ownrs_indirects"
    //     ]


    // };






    var R = [];



    //#############################################################
    //#############################################################



    //  "totals": {


    //     "total_tax": "964.29",
    //     "total_ira": "70.83",
    //     "total_health_insurance": "751.00",
    //     "total_expenses": "10570.00",

    //     "total_weekly_hours": "28.00",


    //     "total_ownr_ira_monthly": "83.33",

    //     "total_empl_direct_indirect_salary_yearly": "28800.00",
    //     "total_ownr_health_insurance_yearly": "6000.00",
    //     "total_empl_indirect_ira_monthly": "37.50",




    //     "total_ownr_salary_pretax_monthly": "4166.67",
    //     "total_ownrs_indirect": "2914.29",
    //     "total_ownr_burden_monthly": "6535.71",

    //     "total": "15272.79",

    //     "total_ownrs": "8202.38",


    //     "total_empl_health_insurance_monthly": "251.00",

    //     "total_empls": "3203.00",



    //     "total_empl_direct_indirect_salary_monthly": "2400.00",

    //     "total_ownr_salary_pretax_yearly": "50000.00",

    //     "total_empl_indirect_tax_monthly": "250.00",
    //     "total_empl_health_insurance_yearly": "3012.00",
    //     "total_empl_direct_indirect_ira_yearly": "864.00",

    //     "total_ownr_ira_yearly": "1000.00",

    //     "total_empl_direct_indirect_tax_monthly": "480.00",
    //     "total_ownr_health_insurance_monthly": "500.00",
    //     "total_empl_indirect_salary_monthly": "1250.00",
    //     "total_empl_direct_indirect_ira_monthly": "72.00",
    //     "total_ownr_taxes_monthly": "1785.71",
    //     "total_empl_burden_yearly": "38436.00",
    //     "total_empls_direct": "1414.50",


    //     "total_empl_direct_ira_monthly": "34.50",
    //     "total_empl_direct_indirect_tax_yearly": "5760.00",

    //     "total_ownr_taxes_monthly_direct": "1071.43",
    //     "total_ownr_taxes_monthly_indirect": "714.29",
    //     "total_ownr_ira_monthly_indirect": "33.33",
    //     "total_ownr_taxes_yearly": "21428.57",

    //     "total_empl_burden_monthly": "3203.00",

    //     "total_ownr_salary_pretax_monthly_indirect": "1666.67",
    //     "total_ownr_burden_yearly": "78428.57",

    //     "total_empls_indirect": "1788.50",

    //     "total_ownrs_direct": "5288.10",

    //     "total_empl_direct_salary_monthly": "1150.00",
    //     "total_empl_direct_tax_monthly": "230.00",
    //     "total_ownr_ira_monthly_direct": "50.00"


    //   }



    //----------------------------------------------------
    // Totals
    //----------------------------------------------------

    var total_monthly = "0.00";
    var total_yearly = "0.00";

    if(zoneObj.calc_dash)
    {
        total_monthly = zoneObj.calc_dash.result_items['totals'].total_ira;
        total_yearly = parseFloat(total_monthly) * 12;
        total_yearly = total_yearly.toFixed(2);

    }//==

    total_monthly = "$"+LibNumber.PrintMoney(total_monthly);
    total_yearly = "$"+LibNumber.PrintMoney(total_yearly);




    //----------------------------------------------------
    // Total Ownrs
    //----------------------------------------------------

    // "ownr-1": {
    //     "name": "Owner A",
    //     "value": {
    //       "ownr_hours_weekly": "40.00",
    //       "ownr_sti_yearly_direct": "43457.14",
    //       "ownr_name": "Owner A",
    //       "ownr_sti_monthly_indirect": "2414.29",
    //       "ownr_labor_indirect": "Outside Sales,Manager",
    //       "ownr_hours_indirect_percent_whole": "40.00",
    //       "ownr_labor_percent_direct": "60.00",
    //       "ownr_taxes_monthly_direct": "1071.43",
    //       "ownr_ira_monthly_indirect": "33.33",
    //       "ownr_labor_percent": "60.00",
    //       "ownr_ira_monthly": "83.33",
    //       "ownr_vacation_weeks": "2.00",
    //       "ownr_ira_percent": "2.00",
    //       "ownr_sti_monthly_direct": "3621.43",
    //       "ownr_hours_indirect_percent": "0.40",
    //       "ownr_taxes_yearly": "21428.57",
    //       "ownr_sti_weekly_direct": "869.14",
    //       "ownr_salary_pretax": "50000.00",
    //       "ownr_flag": "<br/>The owner spends the majority of their time performing direct labor.<br/>40% of the owners salary will be considered an Overhead expense..<br/>Graphic Design, Production and Installation rates will use the owners Direct Labor rate.",
    //       "ownr_taxrate_percent": "30.00",
    //       "ownr_health_insurance_yearly": "6000.00",
    //       "ownr_indirect_hours_yearly": "880.00",
    //       "ownr_taxrate_reciprocal": "0.70",
    //       "ownr_salary_pretax_monthly": "4166.67",
    //       "ownr_working_weeks": "50.00",
    //       "ownr_hours_direct_percent": "0.60",
    //       "ownr_taxrate_decimal": "0.30",
    //       "ownr_hours_indirect": "16.00",
    //       "ownr_sti": "72428.57",
    //       "ownr_taxes_monthly_indirect": "714.29",
    //       "ownr_ira_yearly": "1000.00",
    //       "ownr_ira_monthly_direct": "50.00",
    //       "ownr_labor_direct": "Design,Production and Service",
    //       "ownr_taxes_monthly": "1785.71",
    //       "ownr_labor_percent_indirect": "40.00",
    //       "ownr_hours_direct_percent_whole": "60.00",
    //       "ownr_sti_weekly_indirect": "579.43",
    //       "ownr_billable_hours_weekly": "24.00",
    //       "ownr_ira_decimal": "0.02",
    //       "ownr_billable_hours_daily": "4.80",
    //       "ownr_st": "71428.57",
    //       "ownr_health_insurance_monthly": "500.00",
    //       "ownr_sti_weekly": "1448.57",
    //       "ownr_hours_direct": "24.00",
    //       "ownr_sti_hourly_direct_flag": "Okay",
    //       "ownr_flag_case": "greater",
    //       "ownr_sti_hourly_direct": "36.21",
    //       "ownr_salary_overhead": "1666.67",
    //       "ownr_sti_yearly_indirect": "28971.43"
    //     }
    // },





    //----------------------------------------------------
    // Total Empls
    //----------------------------------------------------

    // "empl-1": {
    //     "name": "Employee 1",
    //     "value": {
    //       "empl_vacation_weeks": "2.00",
    //       "empl_direct_indirect_ira_monthly_total": "72.00",
    //       "empl_burden_hours_yearly": "1920.00",
    //       "empl_name": "Employee 1",
    //       "empl_direct_hourly_rate": "18.45",
    //       "empl_labor_direct": "Van Halen,ACDC",
    //       "empl_labor_percent_indirect": "50.00",
    //       "empl_tax_hourly": "3.00",
    //       "empl_indirect_ira_yearly": "450.00",
    //       "empl_hours_indirect": "20.00",
    //       "empl_direct_ira_monthly": "34.50",
    //       "empl_indirect_tax_yearly": "3000.00",
    //       "empl_direct_indirect_tax_monthly_total": "480.00",
    //       "empl_tax_comp_decimal": "0.20",
    //       "empl_hours_direct": "20.00",
    //       "empl_yearly_salary_w_health_insurance": "31812.00",
    //       "empl_tax_comp_percent": "20.00",
    //       "empl_direct_ira_yearly": "414.00",
    //       "empl_direct_hours_yearly": "920.00",
    //       "empl_indirect_hours_yearly": "1000.00",
    //       "empl_working_weeks": "46.00",
    //       "empl_labor_percent": "50.00",
    //       "empl_health_insurance_weekly": "65.48",
    //       "empl_indirect_salary_monthly": "1250.00",
    //       "empl_direct_indirect_ira_yearly_total": "864.00",
    //       "empl_direct_indirect_salary_yearly_total": "28800.00",
    //       "empl_health_insurance_monthly": "251.00",
    //       "empl_direct_salary_monthly": "1150.00",
    //       "empl_indirect_ira_monthly": "37.50",
    //       "empl_direct_tax_yearly": "2760.00",
    //       "empl_billable_hours_daily": "5.00",
    //       "empl_labor_percent_direct": "50.00",
    //       "empl_direct_salary_yearly": "13800.00",
    //       "empl_hourly_rate": "15.00",
    //       "empl_indirect_salary_yearly": "15000.00",
    //       "empl_direct_tax_monthly": "230.00",
    //       "empl_direct_labor_decimal": "0.50",
    //       "empl_health_insurance_yearly": "3012.00",
    //       "empl_ira_decimal": "0.03",
    //       "empl_burden_monthly_total": "3203.00",
    //       "empl_hours_weekly": "40.00",
    //       "empl_ira_percent": "3.00",
    //       "empl_labor_indirect": "Inside Sales,Accounting",
    //       "empl_health_insurance_hourly": "1.64",
    //       "empl_billable_hours_weekly": "20.00",
    //       "empl_ira_hourly": "0.45",
    //       "empl_direct_indirect_salary_monthly_total": "2400.00",
    //       "empl_burden_yearly_total": "38436.00",
    //       "empl_indirect_hourly_rate": "20.09",
    //       "empl_direct_indirect_tax_yearly_total": "5760.00",
    //       "empl_indirect_tax_monthly": "250.00"
    //     }
    // },


















    // var items = [];

    // keyname = 'IRA'; // "empl";

    // if(VPreportDefaults && VPreportDefaults !== undefined)
    // {
    //     for(item of VPreportDefaults[keyname])
    //     {
    //         items.push(item);
    //     }

    // }
    // //console.log("items::::::"+JSON.stringify(items,null,2));



    var reportItems = [



        //-----------------------------------
        // Graphic and Ledger
        //-----------------------------------

        {

            "print"		    :'bar',
            "name"		    :'Total',
            "value"		    :"",
            "required"	    :"",
            "default"	    :""


        },
        {

            "print"		    :'spacer',
            "name"		    :'',
            "value"		    :{

                backgroundColor:"transparent",
                height:"15px"
            },
            "required"	    :"",
            "default"	    :""


        },
        {

            "print"		    :'report_box',
            "name"		    :'Report Box',
            "value"		    :[

                {

                    boxCall:'graphic',
                    boxWidth:"35%",
                    boxHeight:190,

                    svgCall:"ira",
                    svgWidth:190,
                    svgHeight:190,

                },

                {
                    boxCall:'ledger',
                    boxWidth:"65%",
                    boxHeight:190,
                    value:[

                        {
                            name:"Total Yearly",
                            value:total_yearly
                        },

                        {
                            name:"Total Monthly",
                            value:total_monthly
                        }


                    ]

                }



            ],
            "required"	    :"",
            "default"	    :""


        },
        {

            "print"		    :'spacer',
            "name"		    :'',
            "value"		    :{

                backgroundColor:"transparent",
                height:"20px"
            },
            "required"	    :"",
            "default"	    :""


        },







        // //-----------------------------------
        // // Ledger
        // //-----------------------------------

        // {

        //     "print"		    :'bar',
        //     "name"		    :"Owner's",
        //     "value"		    :"",
        //     "required"	    :"",
        //     "default"	    :""


        // },
        // {

        //     "print"		    :'ledger',
        //     "name"		    :"Ledger",
        //     "value"		    :[


        //         {
        //             name:"Percentage",
        //             value:"3.0%"
        //         },
        //         {
        //             name:"Yearly",
        //             value:"$1500.00"
        //         },
        //         {
        //             name:"Monthly",
        //             value:"$125.00"
        //         }


        //     ],
        //     "required"	    :"",
        //     "default"	    :""


        // },

        // {

        //     "print"		    :'spacer',
        //     "name"		    :'',
        //     "value"		    :{

        //         backgroundColor:"transparent",
        //         height:"30px"
        //     },
        //     "required"	    :"",
        //     "default"	    :""


        // },





        // //-----------------------------------
        // // Ledger
        // //-----------------------------------

        // {

        //     "print"		    :'bar',
        //     "name"		    :"Employee's",
        //     "value"		    :"",
        //     "required"	    :"",
        //     "default"	    :""


        // },
        // {

        //     "print"		    :'ledger',
        //     "name"		    :"Ledger",
        //     "value"		    :[


        //         {
        //             name:"Percentage",
        //             value:"3.0%"
        //         },
        //         {
        //             name:"Yearly",
        //             value:"$1248.00"
        //         },
        //         {
        //             name:"Monthly",
        //             value:"$104.00"
        //         }


        //     ],
        //     "required"	    :"",
        //     "default"	    :""


        // },

        // {

        //     "print"		    :'spacer',
        //     "name"		    :'',
        //     "value"		    :{

        //         backgroundColor:"transparent",
        //         height:"50px"
        //     },
        //     "required"	    :"",
        //     "default"	    :""


        // },



    ];



    R.push({

        call:'report',
        items: reportItems

    });
        
    return R;

}



export default Index;
